import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/fresh-table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate, locateValue } from '@tool/index';

interface IProps {
  tableHead: any[],
  tableList: any[],
}
interface IState {}

const FreshTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { tableHead, tableList } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="fresh-table_10101">
      <section className="fresh-head_10101">
        {tableHead.map((item: any, index: number) => (
          <section key={index}
            className={[
              'line-fresh_01', `line-fresh_00${index + 1}`,
            ].join(' ')}>
            <span>{item.title}</span>

            {index !== 0 ? (
              <p className="line-fresh_03">
                {item.child?.map((text: any, idx: number) => (
                  <span key={idx}>{text}</span>
                ))}
              </p>
            ) : null}
          </section>
        ))}
      </section>

      <section className="fresh-content_10101">
        {tableList.map((item: any, index: number) => (
          <p key={index}
            className={[
              'line-fresh_11', `line-fresh_10${index + 1}`,
            ].join(' ')}>
            <span className="span-100">{item.title}</span>
            {item.arr?.map((text: any, idx: number) => (
              <span key={idx}
                className={[
                  idx !== 0 ? 'span-105' : 'span-101',
                  `span-100${idx + 1}`,
                ].join(' ')}>{text}</span>
            ))}
          </p>
        ))}
      </section>
    </section>
  );
};

export default observer(FreshTable);
